// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import EyeClosedSvg from "static/icons/eye-closed.svg";
import EyeOpenedSvg from "static/icons/eye-opened.svg";

function LoginForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  const url = Buhta_cabinet__Route.useUrl(undefined);
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const env = cfg.app_env;
  React.useEffect((function () {
          const return_to = Buhta_cabinet__Route.getParamValue(url, "return_to", undefined);
          if (return_to !== undefined) {
            const id = Buhta_core__Toast.generateId(undefined);
            Curry._1(setToast, (function (param) {
                    return {
                            id: id,
                            text: "Необходимо авторизоваться",
                            kind: "default",
                            onClick: (function (param) {
                                
                              })
                          };
                  }));
          }
          
        }), [url]);
  const match$1 = React.useState(function () {
        return true;
      });
  const setPasswordHidden = match$1[1];
  const passwordHidden = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setEmail = match$2[1];
  const match$3 = React.useState(function () {
        return "";
      });
  const setPassword = match$3[1];
  const match$4 = React.useState(function () {
        return [];
      });
  const setClosures = match$4[1];
  const closures = match$4[0];
  const errors = payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload") ? payload.VAL.errors : /* [] */0;
  React.useEffect((function () {
          Curry._1(setClosures, (function (param) {
                  return Stdlib__Array.init(Stdlib__List.length(errors), (function (param) {
                                return false;
                              }));
                }));
        }), [errors]);
  const initialFocusRef = React.useRef(null);
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload")) {
    const payload$1 = payload.VAL;
    const __x = payload$1.errors;
    const __x$1 = payload$1.messages;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, error) {
                        const Key = "error-" + String(index);
                        return JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-4 text-white",
                                                  children: error
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                      }),
                                                  className: "border-l border-white-24 ml-3 p-2",
                                                  onClick: (function (param) {
                                                      Curry._1(setClosures, (function (param) {
                                                              return Stdlib__Array.mapi((function (i, param) {
                                                                            return i === index;
                                                                          }), closures);
                                                            }));
                                                    })
                                                })
                                          ],
                                          className: Cn.fromList({
                                                hd: "bg-alert border border-alert-16 rounded flex items-center",
                                                tl: {
                                                  hd: Cn.on("hidden", closures.length !== 0 && Caml_array.get(closures, index)),
                                                  tl: /* [] */0
                                                }
                                              })
                                        }),
                                    className: "fixed z-10 w-screen left-0 top-32 flex justify-center"
                                  }, Key);
                      }))),
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$1, (function (index, msg) {
                        const Key = "message-" + String(index);
                        return JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-4 text-white",
                                                  children: msg
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("img", {
                                                        src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                      }),
                                                  className: "border-l border-white-24 ml-3 p-2 "
                                                })
                                          ],
                                          className: "bg-success rounded flex items-center"
                                        }),
                                    className: "fixed z-10 w-screen left-0 top-32 flex justify-center"
                                  }, Key);
                      }))),
            JsxRuntime.jsx(Buhta_cabinet__Box.make, {
                  title: "Вход",
                  className: "relative",
                  children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                        onSubmit: (function (param) {
                            
                          }),
                        initialFocusRef: initialFocusRef,
                        action: payload$1.action,
                        method_: "POST",
                        className: "mt-8",
                        children: [
                          JsxRuntime.jsx("input", {
                                name: "csrf_token",
                                type: "hidden",
                                value: payload$1.csrfToken
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                label: "Email",
                                type_: "email",
                                name: "identifier",
                                required: true,
                                onChange: (function (value) {
                                    Curry._1(setEmail, (function (param) {
                                            return Stdlib__String.trim(value);
                                          }));
                                  }),
                                inputRef: initialFocusRef,
                                value: match$2[0]
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Пароль",
                                        type_: passwordHidden ? "password" : "text",
                                        name: "password",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setPassword, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        autoComplete: "off",
                                        className: "mt-4",
                                        value: match$3[0]
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: passwordHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                        className: "absolute right-4 top-5",
                                        tabIndex: -1,
                                        type: "button",
                                        onClick: (function (param) {
                                            Curry._1(setPasswordHidden, (function (param) {
                                                    return !passwordHidden;
                                                  }));
                                          })
                                      })
                                ],
                                className: "relative"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("a", {
                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: "text-gray-medium",
                                            children: "Забыли пароль?"
                                          }),
                                      href: env === "production" ? "https://id.buhta.com/auth/recovery" : "https://id.sandbox.buhta.com/auth/recovery"
                                    }),
                                className: "flex justify-end mt-6"
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                kind: "primary",
                                name: "method",
                                value: "password",
                                type_: "submit",
                                className: "mt-6",
                                isWide: true,
                                children: "Войти"
                              }),
                          JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                className: "mt-4 text-asphalt",
                                children: [
                                  "Нажимая, вы соглашаетесь с ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "пользовательским соглашением",
                                              className: "link",
                                              href: "/kz/ru/legal/agreement",
                                              target: "_blank"
                                            })
                                      }),
                                  " и со ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "сбором, обработкой персональных данных",
                                              className: "link",
                                              href: "/kz/ru/legal/consent",
                                              target: "_blank"
                                            })
                                      })
                                ]
                              }),
                          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                className: "mt-6 text-gray-medium",
                                children: [
                                  "Нет аккаунта? ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "Зарегистрироваться",
                                              className: "link",
                                              href: env === "production" ? "https://id.buhta.com/auth/registration" : "https://id.sandbox.buhta.com/auth/registration"
                                            })
                                      })
                                ]
                              })
                        ]
                      })
                })
          ],
          className: "px-4 lg:px-0"
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "No csrf token provided"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: tmp
            });
}

const make = LoginForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
